import gql from 'graphql-tag'

const updateCoupon = gql`
  mutation updateCoupon($coupon: UpdateCoupon!, $id: Int!) {
    updateCoupon(coupon: $coupon, id: $id) {
      id
      codice
      stato
      importo
      clienteId
      cliente {
        id
        nome
      }
      dataCreazione
      dataLimiteAssegnazione
      dataLimiteAttivazione
      dataLimiteUtilizzo
      tipologia
    }
  }
`

export default updateCoupon



// WEBPACK FOOTER //
// ./src/graphql/mutations/updateCoupon.js